export default "__VITE_ASSET__Cc$MiSgR__"